import { useBusConnection } from './context';



export const useEventBus = () => {

    const connectionstate = useBusConnection()
    const self = {

        publish: <T extends any> (topic: string, data: T) => {

            console.log(`publishing ${topic} event`,data)

            const connection = connectionstate.get().connection
            const codec = connectionstate.get().codec

            connection && !connection.isClosed() && connection?.publish(topic, codec.encode(data))
        }

    }


    return self

}